<div class="city-list">
  <h3>{{cities().length}} Cities in {{region.name}}</h3>

  <div class="city-list__content">
    @if(cities().length) {
      <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
        <div class="swiper-wrapper">
          @for(city of cities(); track city.place_id; let idx = $index) {
            <div class="swiper-slide">
              <app-city-card-mobile
                [city]="city"
                [regionName]="region.name"
                [countryName]="countryName"
              ></app-city-card-mobile>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
        <div class="swiper-wrapper">
          @for(city of [1, 2, 3, 4, 5, 6, 7]; track city; let idx = $index) {
            <div class="swiper-slide">
              <app-city-card-mobile
                [isFetching]="true"
              ></app-city-card-mobile>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

